import { addStateReset } from "common/reducer/addStateReset";
import { LanguageDomainActionType } from "domains/language/actionTypes";

export const addLanguageChangeReset = addStateReset(LanguageDomainActionType.FETCH);
